module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/line-badge-nocolor-ea05bb86c5833f80bae127882cdee1ed.svg";